import { notification, Skeleton } from 'antd';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import excelIcon from '@/assets/file-icons/excel.png';
import { useDischargesExcel } from '@/features/contracts/api/use-discharges-excel';
import { downloadFile } from '@/utils/download-file';

type Props = {
  contractIds?: number[];
  objectIds?: number[];
  objectItemIds?: number[];
};

const DownloadSchedulesExcelButton = ({ contractIds, objectIds, objectItemIds }: Props) => {
  const { t } = useTranslation();

  const dischargesExcelQuery = useDischargesExcel({
    params: {
      contractIds,
      objectIds,
      objectItemIds,
    },
    queryConfig: { enabled: false },
  });

  const handleDownload: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.stopPropagation();

    const response = await dischargesExcelQuery.refetch();
    const blob = response?.data?.data;

    if (!blob) {
      return notification.error({
        message: t('somethingWentWrong', { ns: 'common' }),
      });
    }
    downloadFile(blob, `Tühjendusgraafikud_${contractIds || objectIds || objectItemIds}.xlsx`);
  };

  if (dischargesExcelQuery.isLoading) {
    return <Skeleton.Node active className="w-6 h-6" />;
  }

  return (
    <button onClick={handleDownload}>
      <img src={excelIcon} alt="excel" className="w-8 h-8 sm:w-6 sm:h-6" />
    </button>
  );
};

export default DownloadSchedulesExcelButton;
